import Router from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import comum from './routes/comum'
import patrimonio from './routes/patrimonio'
import contaContabil from './routes/conta-contabil'
import relatoriosBuilder from './routes/relatorios'
import movimentacaoExterna from './routes/movimentacao'
import painel from './routes/painel'
import acessos from './routes/acessos'
import reavaliacao from './routes/reavaliacao'
import ajuste from './routes/ajuste'
import store from '../../core/store'

const getRoutesRelatorio = (parametros) => {
    if (parametros) {
        return relatoriosBuilder.build(parametros)
    }
    return []
}

export const getRoutes = (parametros) => {
    return new Router({
            routes: [
                {
                    path: '/',
                    name: 'Inicial',
                    redirect: () => {
                        return {name: 'Acessos'}
                    },
                },
                ...acessos,
                ...painel,
                ...patrimonio,
                ...movimentacaoExterna,
                ...reavaliacao,
                ...ajuste,
                ...contaContabil,
                ...getRoutesRelatorio(parametros),
                ...comum
            ],
            scrollBehavior: (to, from, savedPosition) => {
                let scrollTo = 0

                if (to.hash) {
                    scrollTo = to.hash
                } else if (savedPosition) {
                    scrollTo = savedPosition.y
                }

                return goTo(scrollTo)
            }
        }
    )
}
export default getRoutes(store.state.parametros.parametros)
